import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/free-solid-svg-icons'
import RichTextEditor from './RichTextEditor'

type Props = {
  newAreaName: string
  newAreaDesc: string
  onChangeName: (value: string) => void
  onChangeDesc: (value: string) => void
  onSubmit: () => void
  onCancel: () => void
}

export function AddCompetencyForm({
  newAreaName,
  newAreaDesc,
  onChangeName,
  onChangeDesc,
  onSubmit,
  onCancel,
}: Props) {
  return (
    <div className="gw-wm__form-panel">
      <h3 className="gw-wm__form-panel-title">Add new competency</h3>
      <p className="gw-wm__hint-sm mb-2">Top-level theme.</p>
      <div className="gw-wm__form-stack">
        <div>
          <label className="gw-wm__label">Competency name</label>
          <input
            type="text"
            className="gw-wm__input"
            value={newAreaName}
            onChange={e => onChangeName(e.target.value)}
          />
        </div>
        <div>
          <label className="gw-wm__label">Description</label>
          <RichTextEditor
            value={newAreaDesc}
            onChange={val => onChangeDesc(val)}
            placeholder="Brief description of this competency"
          />
        </div>
        <div className="gw-wm__btn-row">
          <button
            type="button"
            className="gw-wm__btn-primary"
            disabled={!newAreaName.trim()}
            onClick={onSubmit}
          >
            <FontAwesomeIcon icon={faCheck} />
            Add Competency
          </button>
          <button type="button" className="gw-wm__btn-secondary" onClick={onCancel}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  )
}
